export default __webpack_public_path__ + "static/media/facility-management-da.5c15942d.png";